import styled from "styled-components";
import { Box, Container } from "src/components/material-ui";
import LoopupLogo from "src/components/LoopupLogo";

const LogoContainer = styled.div`
  position: absolute;
  top: 4rem;
  left: 50%;
  transform: translate(-50%, -50%);

  svg {
    height: 2.5rem;
    width: 100%;
  }
`;

const ErrorPageLayout = ({ children }) => (
  <Box
    py={30}
    boxSizing="border-box"
    display="flex"
    flex="1"
    flexDirection="column"
    justifyContent="center"
    minHeight="100vh"
  >
    <LogoContainer>
      <LoopupLogo />
    </LogoContainer>

    <Container maxWidth="sm">{children}</Container>
  </Box>
);

export default ErrorPageLayout;
